import React, { useState, useEffect } from 'react';
import { Spin, Alert, Table, Modal } from 'antd'; // Add Modal to imports
import axios from 'axios';
import Chart from 'chart.js/auto';
import NavbarMex from '../components/navbarMex';
import BotonWhatsapp from '../botonWhatsapp/botonWhatsapp';
import './DashboardMex.css';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { SucursalesError } from '../../sucursalesError/sucursalesError';

const Dashboard = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dashboardData, setDashboardData] = useState(null);
  const [idsucursal, setIdsucursal] = useState('');
  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [novedadesDiarias, setNovedadesDiarias] = useState([]);
  const [showGraphs, setShowGraphs] = useState(false);
  const [charts, setCharts] = useState([]); // Add this state to store chart instances
  const [evolucionData, setEvolucionData] = useState(null);
  const [selectedCalendly, setSelectedCalendly] = useState('general');
  const [showCalendly, setShowCalendly] = useState(false);
  const codigo_sucursal = localStorage.getItem('codigoSucursal');

  const calendlyUrls = {
    general: 'https://calendly.com/99envios/capacitacion-99-envios',
    masivas: 'https://calendly.com/99envios/guias-masivas-99-envios',
    dropshipping: 'https://calendly.com/99envios/dropshipping-99-envios',
    shopify: 'https://calendly.com/99envios/integracion-shopify-99-envios',
    publicidad: 'https://calendly.com/99envios/asesoria-publicitaria'
  };

  const ordenDeseado = [
    "Entregada",
    "Devolución ratificada",
    "Devolucion Regional",
    "Creado",
    "Transito nacional",
    "Centro acopio",
    "Admitida",
    "Mercancía no despachada por el"
  ];

  const estadosOrdenados = dashboardData?.data.estados_envios_cartera
    ? dashboardData.data.estados_envios_cartera.sort((a, b) =>
      ordenDeseado.indexOf(a.estado_del_envio) - ordenDeseado.indexOf(b.estado_del_envio)
    )
    : [];

  const usuario_id = localStorage.getItem('usuario_id');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSucursalId = async () => {
      try {
        const response = await axios.get(`https://99envios.app/api/online/sucursal-codigo-sucursal/${usuario_id}`);
        setIdsucursal(response.data);
      } catch (error) {
        console.error('Error al obtener el ID de la sucursal', error);
      }
    };

    if (usuario_id) {
      fetchSucursalId();
    }
  }, [usuario_id]);

  useEffect(() => {
    const checkSucursalError = () => {
      if (SucursalesError.some(item => item.value === codigo_sucursal)) {
        setShowErrorModal(true);
      }
    };

    checkSucursalError();
  }, [codigo_sucursal]);

  useEffect(() => {
    if (idsucursal) {
      fetchData();
    }
  }, [idsucursal, startDate, endDate]);

  const fetchData = async () => {
    setLoading(true);
    const desde = startDate || moment().subtract(1, 'year').format('YYYY-MM-DD');
    const hasta = endDate || moment().format('YYYY-MM-DD');

    try {
      const usuario_id = localStorage.getItem('usuario_id');
      const response = await axios.get(`https://99envios.app/api/online/home/${usuario_id}/${desde}/${hasta}`, {
        headers: {
          'Accept': 'application/json'
        }
      });
      setDashboardData(response.data);
    } catch (error) {
      console.error('Error al obtener los datos de la API', error);
    } finally {
      setLoading(false);
    }
  };

  const estadosUnificados = dashboardData?.data.estados_envios_cartera.reduce((acumulador, estado) => {
    const estadoNombre = estado.estado_del_envio;

    if (estadoNombre === "Entregada" || estadoNombre === "Entregado") {
      const entregadoExistente = acumulador.find(e => e.estado_del_envio === "Entregado");
      if (entregadoExistente) {
        entregadoExistente.total_envios += estado.total_envios;
      } else {
        acumulador.push({ estado_del_envio: "Entregado", total_envios: estado.total_envios });
      }
    } else {
      // Mantiene el resto de los estados tal como están
      acumulador.push(estado);
    }

    return acumulador;
  }, []);


  const totalEnvios = dashboardData?.data.estados_envios_cartera
    .reduce((total, estado) => total + estado.total_envios, 0) || 0;

  const totalEntregado = dashboardData?.data.estados_envios_cartera
    .filter((estado) => ["Entregada", "Entregado"].includes(estado.estado_del_envio))
    .reduce((total, estado) => total + estado.total_envios, 0) || 0;

  const devoluciones = dashboardData?.data.estados_envios_cartera
    .filter((estado) => ["Devolución ratificada", "Devolucion Regional"].includes(estado.estado_del_envio))
    .reduce((total, estado) => total + estado.total_envios, 0) || 0;

  // Nuevo cálculo de tasas
  const tasaDevolucion = totalEnvios > 0 ? (devoluciones / totalEnvios) * 100 : 0;
  const tasaEntrega = totalEnvios > 0 ? 100 - tasaDevolucion : 0;

  // Formatear las tasas para mostrar
  const tasaDevolucionFormateada = tasaDevolucion.toFixed(2) + '%';
  const tasaEntregaFormateada = tasaEntrega.toFixed(2) + '%';

  const estadoEnvios = dashboardData?.data.estados_envios_cartera || [];
  const destinosUsados = dashboardData?.data.destinos_mas_usados || [];
  const devolucionesFrecuentes = dashboardData?.data.resultado_en_movimiento || [];
  const enviosCompleto = dashboardData?.datalist.ordenes_recientes || [];
  const carteraCompleta = dashboardData?.datalist.cartera_recientes || [];
  const consolidadoConsignaciones = dashboardData?.datalist.consolidado_cartera || [];

  const fetchModalMessage = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/modals');
      if (response.data && response.data.activo) {
        setModalMessage(response.data);
      }
    } catch (error) {
      console.error('Error al obtener el mensaje del modal', error);
    }
  };

  const fetchNovedadesDiarias = async () => {
    try {
      const response = await axios.get(`https://api.99envios.app/public/api/online/novedades-beta/${codigo_sucursal}`);
      setNovedadesDiarias(response.data);
    } catch (error) {
      console.error('Error al obtener las novedades diarias', error);
    }
  };

  // Add fetchEvolucionData function
  const fetchEvolucionData = async () => {
    try {
      const response = await axios.get(`https://integration.99envios.app/api/tabla_seguro99/${codigo_sucursal}/8`);
      setEvolucionData(response.data);
    } catch (error) {
      console.error('Error al obtener datos de evolución', error);
    }
  };

  useEffect(() => {
    fetchModalMessage();
    fetchNovedadesDiarias();
  }, []);

  useEffect(() => {
    if (codigo_sucursal) {
      fetchEvolucionData();
    }
  }, [codigo_sucursal]);

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Return original if invalid
    return date.toISOString().split('T')[0];
  };

  // Nuevas definiciones de columnas para las tablas de dashboard
  const columnsNovedades = [
    { title: 'Número de Guía', dataIndex: 'numero_preenvio', key: 'numero_preenvio', align: 'center' },
    { title: 'Novedad Sucursal', dataIndex: 'novedad_sucursal', key: 'novedad_sucursal', align: 'center' },
    { title: 'Tipo de Novedad', dataIndex: 'tipo_novedad', key: 'tipo_novedad', align: 'center' },
    { title: 'Ciudad', dataIndex: 'ciudad_destinatario', key: 'ciudad_destinatario', align: 'center' },
    { title: 'Fecha de Actualización', dataIndex: 'updated_at', key: 'updated_at', align: 'center', render: text => formatDateForDisplay(text) }
  ];

  const columnsEnvios = [
    { title: 'Número de Guía', dataIndex: 'numero_de_guia', key: 'numero_de_guia', align: 'center' },
    { title: 'Fecha de envío', dataIndex: 'fecha_envio', key: 'fecha_envio', align: 'center' },
    { title: 'Valor comercial', dataIndex: 'valor_comercial', key: 'valor_comercial', align: 'center' },
    { title: 'Ciudad', dataIndex: 'ciudad_destino', key: 'ciudad_destino', align: 'center' },
    { title: 'Producto', dataIndex: 'Producto', key: 'Producto', align: 'center' }
  ];

  const columnsCartera = [
    { title: 'Número de Guía', dataIndex: 'numero_de_guia', key: 'numero_de_guia', align: 'center' },
    { 
      title: <div style={{ whiteSpace: 'pre-line' }}>Valor Comercial</div>, 
      dataIndex: 'valor_comercial', 
      key: 'valor_comercial',
      align: 'center'
    },
    { 
      title: <div style={{ whiteSpace: 'pre-line' }}>Valor Flete</div>, 
      dataIndex: 'valor_flete', 
      key: 'valor_flete',
      align: 'center'
    },
    { title: 'Valor Consignado', dataIndex: 'valor_consignado', key: 'valor_consignado', align: 'center' },
    { title: 'Estado de Envío', dataIndex: 'estado_del_envio', key: 'estado_del_envio', align: 'center' }
  ];

  const columnsConsolidado = [
    { title: 'Fecha de Consignación', dataIndex: 'fecha_de_pago', key: 'fecha_de_pago', align: 'center' },
    { title: 'Valor Consignado', dataIndex: 'total_por_dia', key: 'total_por_dia', align: 'center' }
  ];

  // Add this useEffect for chart initialization
  useEffect(() => {
    if (showGraphs && dashboardData && !loading) {
      // Destroy previous charts if they exist
      charts.forEach(chart => chart.destroy());
      
      // Initialize estados envíos chart
      const estadosCtx = document.getElementById('estadosEnviosChart');
      const estadosChart = new Chart(estadosCtx, {
        type: 'bar',
        data: {
          labels: estadosUnificados.map(estado => estado.estado_del_envio),
          datasets: [{
            label: 'Total de envíos',
            data: estadosUnificados.map(estado => estado.total_envios),
            backgroundColor: '#7380ec',
            borderColor: '#7380ec',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      });

      // Initialize destinos chart
      const destinosCtx = document.getElementById('destinosChart');
      const destinosChart = new Chart(destinosCtx, {
        type: 'bar',
        data: {
          labels: destinosUsados.map(destino => destino.ciudad_destino),
          datasets: [{
            label: 'Total de envíos por destino',
            data: destinosUsados.map(destino => destino.total_envios),
            backgroundColor: '#41f1b6',
            borderColor: '#41f1b6',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      });

      // Initialize tasas chart
      const tasasCtx = document.getElementById('tasasChart');
      const tasasChart = new Chart(tasasCtx, {
        type: 'bar',
        data: {
          labels: ['Tasa de Entrega', 'Tasa de Devolución'],
          datasets: [{
            label: 'Porcentaje',
            data: [tasaEntrega, tasaDevolucion],
            backgroundColor: ['#4caf50', '#f44336'],
            borderColor: ['#4caf50', '#f44336'],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback: function(value) {
                  return value + '%';
                }
              }
            }
          }
        }
      });

      // Initialize evolución chart
      if (evolucionData) {
        const evolucionCtx = document.getElementById('evolucionChart');
        const evolucionChart = new Chart(evolucionCtx, {
          type: 'line',
          data: {
            labels: evolucionData.evolucion_semanal.map(item => item.nombre_semana),
            datasets: [
              {
                label: 'Entregas (%)',
                data: evolucionData.evolucion_semanal.map(item => item.datos_semana.porcentaje_estado_3 * 100),
                borderColor: '#4caf50',
                backgroundColor: 'rgba(76, 175, 80, 0.05)',
                borderWidth: 2,
                tension: 0.4,
                fill: true,
                pointRadius: 5,
                pointBackgroundColor: '#fff',
                pointBorderColor: '#4caf50',
                pointBorderWidth: 2
              },
              {
                label: 'Devoluciones (%)',
                data: evolucionData.evolucion_semanal.map(item => item.datos_semana.porcentaje_estado_5 * 100),
                borderColor: '#f44336',
                backgroundColor: 'rgba(244, 67, 54, 0.05)',
                borderWidth: 2,
                tension: 0.4,
                fill: true,
                pointRadius: 5,
                pointBackgroundColor: '#fff',
                pointBorderColor: '#f44336',
                pointBorderWidth: 2
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                top: 40,
                right: 30,
                bottom: 10,
                left: 20
              }
            },
            plugins: {
              title: {
                display: true,
                text: 'Evolucion Seguro Antidevoluciones (%)',
                font: { size: 16, weight: 'bold' }
              },
              legend: {
                position: 'top',
                labels: {
                  usePointStyle: true,
                  font: { size: 12, weight: 'bold' }
                }
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                max: 100,
                grid: {
                  color: 'rgba(0, 0, 0, 0.1)',
                  drawTicks: true,
                  lineWidth: 1
                },
                ticks: {
                  stepSize: 10,
                  callback: value => value + '%',
                  font: { size: 11, weight: 'bold' }
                }
              },
              x: {
                grid: { display: false },
                ticks: {
                  maxRotation: 45,
                  minRotation: 45
                }
              }
            }
          },
          plugins: [{
            afterDraw: function(chart) {
              const ctx = chart.ctx;
              // Draw horizontal grid lines first
              ctx.save();
              const yAxis = chart.scales.y;
              const xAxis = chart.scales.x;
              for (let i = 0; i <= 100; i += 10) {
                const y = yAxis.getPixelForValue(i);
                ctx.strokeStyle = 'rgba(0, 0, 0, 0.05)';
                ctx.beginPath();
                ctx.moveTo(xAxis.left, y);
                ctx.lineTo(xAxis.right, y);
                ctx.stroke();
              }
              ctx.restore();
              
              // Draw percentage labels
              ctx.save();
              chart.data.datasets.forEach((dataset, i) => {
                const meta = chart.getDatasetMeta(i);
                if (!meta.hidden) {
                  meta.data.forEach((element, index) => {
                    const value = dataset.data[index];
                    if (value !== null) {
                      const yOffset = i === 0 ? -15 : 15;
                      ctx.fillStyle = dataset.borderColor;
                      ctx.font = 'bold 11px Arial';
                      ctx.textAlign = 'center';
                      ctx.fillText(value.toFixed(1) + '%', element.x, element.y + yOffset);
                    }
                  });
                }
              });
              ctx.restore();
            }
          }]
        });
        setCharts([estadosChart, destinosChart, tasasChart, evolucionChart]);
      } else {
        setCharts([estadosChart, destinosChart, tasasChart]);
      }
    }

    return () => {
      charts.forEach(chart => chart.destroy());
    };
  }, [showGraphs, dashboardData, loading]);

  useEffect(() => {
    const loadCalendlyScript = () => {
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    if (showCalendly) {
      loadCalendlyScript()
        .then(() => {
          const container = document.getElementById('calendly-widget-container');
          if (container) {
            container.innerHTML = '';
            window.Calendly.initInlineWidget({
              url: calendlyUrls[selectedCalendly],
              parentElement: container,
            });
          }
        })
        .catch(error => console.error('Error loading Calendly:', error));
    }
  }, [showCalendly, selectedCalendly, calendlyUrls]);

  const handleCalendlyButton = (type) => {
    if (selectedCalendly === type) {
      setShowCalendly(!showCalendly);
    } else {
      setSelectedCalendly(type);
      setShowCalendly(true);
    }
  };

  return (
    <>
      <NavbarMex title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <span>Dashboard</span>
          <button 
            onClick={() => setShowGraphs(!showGraphs)}
            className="graph-button"
            style={{
              padding: '8px 16px',
              backgroundColor: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            {showGraphs ? 'Ver Dashboard' : 'Ver Gráficos'}
          </button>
        </div>
      } />
      <div className="dashboard-containerM">
        <div className="calendly-container">
          <h2 className="calendly-title">Agendar Capacitación</h2>
          <p className="calendly-description">Reserve su espacio para una sesión de capacitación personalizada con nuestro equipo.</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '15px', justifyContent: 'center' }}>
            <button 
              onClick={() => handleCalendlyButton('general')}
              className="calendly-expand-button"
              style={{
                padding: '10px 20px',
                backgroundColor: selectedCalendly === 'general' ? '#1890ff' : '#f5f5f5',
                color: selectedCalendly === 'general' ? 'white' : '#333',
                border: '1px solid #d9d9d9',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Capacitación General
            </button>
            <button 
              onClick={() => handleCalendlyButton('masivas')}
              className="calendly-expand-button"
              style={{
                padding: '10px 20px',
                backgroundColor: selectedCalendly === 'masivas' ? '#1890ff' : '#f5f5f5',
                color: selectedCalendly === 'masivas' ? 'white' : '#333',
                border: '1px solid #d9d9d9',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Guías Masivas
            </button>
            <button 
              onClick={() => handleCalendlyButton('dropshipping')}
              className="calendly-expand-button"
              style={{
                padding: '10px 20px',
                backgroundColor: selectedCalendly === 'dropshipping' ? '#1890ff' : '#f5f5f5',
                color: selectedCalendly === 'dropshipping' ? 'white' : '#333',
                border: '1px solid #d9d9d9',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Dropshipping
            </button>
            {/* Publicidad */}
            <button
              onClick={() => handleCalendlyButton('publicidad')}
              className="calendly-expand-button"
              style={{
                padding: '10px 20px',
                backgroundColor: selectedCalendly === 'publicidad' ? '#1890ff' : '#f5f5f5',
                color: selectedCalendly === 'publicidad' ? 'white' : '#333',
                border: '1px solid #d9d9d9',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Publicidad
            </button>
            <button 
              onClick={() => handleCalendlyButton('shopify')}
              className="calendly-expand-button"
              style={{
                padding: '10px 20px',
                backgroundColor: selectedCalendly === 'shopify' ? '#1890ff' : '#f5f5f5',
                color: selectedCalendly === 'shopify' ? 'white' : '#333',
                border: '1px solid #d9d9d9',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Shopify
            </button>
          </div>
          <div 
            id="calendly-widget-container"
            className="calendly-inline-widget" 
            data-url={calendlyUrls[selectedCalendly]}
            style={{ 
              minWidth: '320px', 
              height: '700px', 
              marginTop: '20px',
              display: showCalendly ? 'block' : 'none' 
            }}
          />
        </div>

        <div className="date-search-container">
          <div className="date-pickerM-containerM">
            <div className="date-pickerM-row">
              <div className="date-pickerM">
                <label>Fecha inicio:</label>
                <input
                  type="date"
                  id="startDate"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="date-pickerM">
                <label>Fecha de corte:</label>
                <input
                  type="date"
                  id="endDate"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
            <div className="button-container">
              <button onClick={fetchData} className="search-buttonM">Buscar Resultados</button>
            </div>
          </div>

          <div className="preenvios-card">
            <div className="preenvios-title">Total Preenvíos del Mes Actual</div>
            <div className="preenvios-count">{dashboardData?.data?.total_preenvios_mes_actual || 0}</div>
          </div>
        </div>

        {showGraphs ? (
          <div className="graphs-container">
            {loading ? (
              <div className="loading-container">
                <Spin size="large" />
              </div>
            ) : dashboardData && (
              <div className="graphs-layout">
                <div className="graphs-bottom">
                  {/* Tasa de Entrega vs Devolución - Abajo Derecha */}
                  <div className="graph-card tasas">
                    <h3>Tasa de Entrega vs Devolución</h3>
                    <div className="graph-content">
                      <canvas id="tasasChart"></canvas>
                    </div>
                  </div>

                  {/* Estado de Envíos Gráfico - Abajo Izquierda */}
                  <div className="graph-card estados">
                    <h3>Estado de Envíos</h3>
                    <div className="graph-content">
                      <canvas id="estadosEnviosChart"></canvas>
                    </div>
                  </div>
                </div>
                {/* Destinos más Usados Gráfico - Arriba */}
                <div className="graph-card destinos">
                  <h3>Destinos más Usados</h3>
                  <div className="graph-content">
                    <canvas id="destinosChart"></canvas>
                  </div>
                </div>
                {/* Evolución Semanal Chart */}
                <div className="graph-card evolucion">
                  <h3>Evolución Semanal</h3>
                  <div className="graph-content">
                    <canvas id="evolucionChart"></canvas>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          loading ? (
            <div className="loading-container">
              <Spin size="large" /> {/* Rueda de carga de Ant Design */}
            </div>
          ) : (
            dashboardData && (
              <div className="cards-containerDM">
                {/* Tarjetas principales */}
                <div className="rowDM">
                  <div className="cardDM">
                    <div className="icon-circle-DM local-shipping-icon">
                      <span className="material-icons-sharp" style={{ fontSize: '28px' }}>local_shipping</span>
                    </div>
                    <h3>Total Envíos</h3>
                    <p className="main-number">{totalEnvios}</p>
                  </div>
                  <div className="cardDM">
                    <div className="icon-circle-DM check-circle-icon">
                      <span className="material-icons-sharp" style={{ fontSize: '28px' }}>trending_up</span>
                    </div>
                    <h3>Total Entregado</h3>
                    <p className="main-number">{totalEntregado}</p>
                  </div>
                  <div className="cardDM">
                    <div className="icon-circle-DM report-icon">
                      <span className="material-icons-sharp" style={{ fontSize: '28px' }}>repartition</span>
                    </div>
                    <h3>Devoluciones</h3>
                    <p className="main-number">{devoluciones}</p>
                    <div className="rate-container">
                      <span className="material-icons error-icon">cancel</span>
                      <p className="rate">Tasa de Devolución</p>
                    </div>
                    <p className="success" style={{ color: "#F44336", textAlign: "left", fontSize: "18px" }}>
                      {tasaDevolucionFormateada}
                    </p>
                  </div>
                </div>

                <div className="rowDM">
                  {/* Tarjeta: Estado envíos */}
                  <div className="cardDM">
                    <div className="icon-circle-DM local-shipping-icon">
                      <span className="material-icons-sharp" style={{ fontSize: '28px' }}>stacked_line_chart</span>
                    </div>
                    <h3>Estado Envios</h3>
                    <table className="card-table-DM">
                      <tbody>
                        {estadosUnificados.map((estado, index) => (
                          <tr key={index}>
                            <td>{estado.estado_del_envio || "Desconocido"}</td>
                            <td className="number-cell-DM">{estado.total_envios}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Tarjeta: Destinos más usados */}

                  <div className="cardDM">
                    <div className="icon-circle-DM check-circle-icon">
                      <span className="material-icons-sharp" style={{ fontSize: '28px' }}>scale</span>
                    </div>
                    <h3>Destinos Más Usados</h3>
                    <table className="card-table-DM">
                      <tbody>
                        {(showMore ? destinosUsados : destinosUsados.slice(0, 5)).map((destino, index) => (
                          <tr key={index}>
                            <td>{destino.ciudad_destino}</td>
                            <td className="number-cell-DM">{destino.total_envios}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {destinosUsados.length > 5 && (
                      <span
                        onClick={() => setShowMore(!showMore)}
                        style={{
                          color: "#7380ec", // mismo color morado de la tabla
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginLeft: "40%",
                          marginTop: "2%",
                          fontSize: "12px",       // tamaño de fuente reducido
                          lineHeight: "1",        // menos alto
                        }}
                      >
                        {showMore ? "Ver menos" : "Ver más"}
                      </span>
                    )}
                  </div>



                  {/* Tarjeta: Devoluciones frecuentes */}
                  <div className="cardDM">
                    <div className="icon-circle-DM report-icon">
                      <span className="material-icons-sharp" style={{ fontSize: '28px' }}>warning</span>
                    </div>
                    <h3>Devoluciones Frecuentes</h3>
                    <table className="card-table-DM">
                      <tbody>
                        {devolucionesFrecuentes.map((movimiento, index) => (
                          <tr key={index}>
                            <td>{movimiento.telefono}</td>
                            <td className="number-cell-DM">{movimiento.num_ocurrencias}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Tabla de Novedades Diarias */}
                <div className="dashboardMex-container">
                  <h3 className="dashboardMex-title">Novedades Diarias</h3>
                  <Table
                    dataSource={novedadesDiarias}
                    columns={columnsNovedades}
                    rowKey="numero_preenvio"
                    bordered
                    size="small"
                    pagination={{ pageSizeOptions: ['5', '10', '20'], showSizeChanger: true, defaultPageSize: 5 }}
                  />
                </div>
                <button
                  className="dashboardMex-button ver-mas"
                  onClick={() => navigate('/dashboard99/novedades')}
                >
                  Gestionar Novedades
                </button>

                {/* Tabla de Envíos Completo */}
                <div className="dashboardMex-container">
                  <h3 className="dashboardMex-title">Envíos Completos</h3>
                  <Table
                    dataSource={enviosCompleto}
                    columns={columnsEnvios}
                    rowKey="numero_de_guia"
                    bordered
                    size="small"
                    pagination={{ pageSizeOptions: ['5', '10', '20'], showSizeChanger: true, defaultPageSize: 5 }}
                    scroll={{ x: 'max-content' }}
                  />
                </div>
                <button
                  className="dashboardMex-button ver-mas"
                  onClick={() => navigate('/dashboard99/envios-completos')}
                >
                  Ver más
                </button>

                {/* Tabla de Cartera Completa */}
                <div className="dashboardMex-container">
                  <h3 className="dashboardMex-title">Cartera Completa</h3>
                  <Table
                    dataSource={carteraCompleta}
                    columns={columnsCartera}
                    rowKey="numero_de_guia"
                    bordered
                    size="small"
                    pagination={{ pageSizeOptions: ['5', '10', '20'], showSizeChanger: true, defaultPageSize: 5 }}
                    scroll={{ x: 'max-content' }}
                  />
                </div>
                <button
                  className="dashboardMex-button ver-mas"
                  onClick={() => navigate('/dashboard99/cartera-completa')}
                >
                  Ver más
                </button>

                {/* Tabla de Consolidado Consignaciones */}
                <div className="dashboardMex-container">
                  <h3 className="dashboardMex-title">Consolidado Consignaciones</h3>
                  <Table
                    dataSource={consolidadoConsignaciones}
                    columns={columnsConsolidado}
                    rowKey="fecha_de_pago"
                    bordered
                    size="small"
                    pagination={{ pageSizeOptions: ['5', '10', '20'], showSizeChanger: true, defaultPageSize: 5 }}
                    scroll={{ x: 'max-content' }}
                  />
                </div>

              </div>
            )
          )
        )}
      </div>
      <BotonWhatsapp />
    </>
  );

};

export default Dashboard;